<template>
  <div class="invitation-page-wrapper">
    <Banner :bannerImg="Img1"></Banner>

    <!-- 面包屑 -->
    <div class="Crumbs container-fixed">
      <div>
        当前位置：<router-link to="/">首页</router-link> &gt;
        <span>广西招投标公告</span>
      </div>
    </div>

    <main class="main-content container-fixed">
      <!-- 搜索栏 - 现代化大厂风格 -->
      <section class="search-section">
        <div class="search-container card-modern">
          <div class="search-input-group">
            <el-input
              v-if="caigoulist"
              placeholder="搜索采购公告信息 (标题、发布单位...)"
              v-model="inputSearchList"
              clearable
              @keyup.enter.native="caiGouListSearch"
            >
              <el-button
                slot="append"
                type="primary"
                icon="el-icon-search"
                @click="caiGouListSearch"
              >
                搜索公告
              </el-button>
            </el-input>

            <el-input
              v-if="caigoutable"
              placeholder="搜索政府采购意向 (标题、采购单位...)"
              v-model="inputSearchTable"
              clearable
              @keyup.enter.native="caiGouTableSearch"
            >
              <el-button
                slot="append"
                type="primary"
                icon="el-icon-search"
                @click="caiGouTableSearch"
              >
                搜索意向
              </el-button>
            </el-input>
          </div>
        </div>
      </section>

      <!-- 选项卡内容 -->
      <section class="content-tabs-section">
        <el-tabs
          v-model="activeName"
          type="card"
          @tab-click="handleClick"
          class="custom-tabs"
        >
          <el-tab-pane label="采购公告信息" name="first">
            <div class="tab-pane-content">
              <CaiGouListContents
                :searchString="searchListString"
              ></CaiGouListContents>
            </div>
          </el-tab-pane>
          <el-tab-pane label="政府采购意向" name="second">
            <div class="tab-pane-content">
              <CaiGouTableContents
                :searchString="searchTableString"
              ></CaiGouTableContents>
            </div>
          </el-tab-pane>
        </el-tabs>
      </section>
    </main>
  </div>
</template>

<script>
import cailist from "./procure/cailist.vue";
import caitable from "./procure/caitable.vue";
import Banner from "../components/banner.vue";

export default {
  name: "Invitation",
  components: {
    Banner,
    CaiGouListContents: cailist,
    CaiGouTableContents: caitable,
  },
  data() {
    return {
      Img1: require("../assets/images/newsbanner.jpg"),
      activeName: "first",
      loading: true,
      caigoulist: true,
      caigoutable: false,
      inputSearchList: null,
      inputSearchTable: null,
      tabsIndex: 0,
      searchTableString: null,
      searchListString: null,
    };
  },
  methods: {
    handleClick(tab) {
      this.tabsIndex = parseInt(tab.index);
      switch (this.tabsIndex) {
        case 0:
          this.caigoulist = true;
          this.caigoutable = false;
          break;
        case 1:
          this.caigoulist = false;
          this.caigoutable = true;
          break;
      }
    },
    caiGouListSearch() {
      this.searchListString = this.inputSearchList;
    },
    caiGouTableSearch() {
      this.searchTableString = this.inputSearchTable;
    },
  },
};
</script>

<style lang="less" scoped>
@import "../assets/styles/variables.less";

.invitation-page-wrapper {
  background-color: @bg-base;
  min-height: 100vh;
  display: flex;
  flex-direction: column;
}

.Crumbs {
  padding: 20px 0;
  font-size: 14px;
  color: @text-secondary;
  span {
    color: @text-main;
    font-weight: 500;
  }
  a:hover {
    color: @primary-color;
  }
}

.main-content {
  flex: 1;
  padding-bottom: 80px;
}

/* 搜索栏 */
.search-section {
  margin-bottom: 40px;
}

.search-container {
  background: #fff;
  padding: 32px;
  border-radius: @border-radius;
}

.search-input-group {
  max-width: 800px;
  margin: 0 auto;

  /deep/ .el-input-group__append {
    background-color: @primary-color;
    border-color: @primary-color;
    color: #fff;
    padding: 0 30px;
    font-weight: 600;
    transition: all 0.3s;

    &:hover {
      background-color: @primary-hover;
      border-color: @primary-hover;
    }

    .el-button {
      color: #fff;
      margin: 0;
    }
  }

  /deep/ .el-input__inner {
    height: 50px;
    line-height: 50px;
    font-size: 16px;
    border-radius: 4px 0 0 4px;
    padding-left: 20px;

    &:focus {
      border-color: @primary-color;
    }
  }
}

/* 选项卡 */
.content-tabs-section {
  .custom-tabs {
    /deep/ .el-tabs__header {
      margin-bottom: 30px;
      border-bottom: none;

      .el-tabs__nav {
        border: none;
        gap: 12px;
      }

      .el-tabs__item {
        height: 46px;
        line-height: 46px;
        font-size: 16px;
        font-weight: 500;
        color: @text-secondary;
        background: #fff;
        border: 1px solid @border-color;
        border-radius: 4px;
        transition: all 0.3s;

        &:hover {
          color: @primary-color;
          border-color: @primary-color;
        }

        &.is-active {
          background: @primary-color;
          color: #fff;
          border-color: @primary-color;
        }
      }
    }
  }
}

.tab-pane-content {
  background: #fff;
  padding: 24px;
  border-radius: @border-radius;
  box-shadow: @shadow-sm;
}
</style>
